import { darken, lighten } from "@mui/material";

import { createTheme } from "@aws-amplify/ui-react";
import { themeDefinitions } from "./mui5themes";

export const awsTheme = (themeID = 0) => {
  const muiTheme = themeDefinitions[themeID];

  const awsTheme = createTheme({
    name: "custom-theme",
    tokens: {
      colors: {
        black: {
          value: muiTheme.palette.commonground.contrastText,
        },
        font: {
          primary: { value: muiTheme.palette.commonground.contrastText },
          font: {
            interactive: {
              value: muiTheme.palette.commonground.contrastText,
            },
          },
        },
        brand: {
          primary: {
            10: lighten(muiTheme.palette.primary.main, 0.35),
            20: lighten(muiTheme.palette.primary.main, 0.3),
            30: lighten(muiTheme.palette.primary.main, 0.25),
            40: lighten(muiTheme.palette.primary.main, 0.2),
            50: lighten(muiTheme.palette.primary.main, 0.15),
            60: lighten(muiTheme.palette.primary.main, 0.1),
            70: lighten(muiTheme.palette.primary.main, 0.05),
            80: muiTheme.palette.primary.main,
            90: darken(muiTheme.palette.primary.main, 0.2),
            100: darken(muiTheme.palette.primary.main, 0.3),
          },
          secondary: {
            10: lighten(muiTheme.palette.secondary.main, 0.35),
            20: lighten(muiTheme.palette.secondary.main, 0.3),
            30: lighten(muiTheme.palette.secondary.main, 0.25),
            40: lighten(muiTheme.palette.secondary.main, 0.2),
            50: lighten(muiTheme.palette.secondary.main, 0.15),
            60: lighten(muiTheme.palette.secondary.main, 0.1),
            70: lighten(muiTheme.palette.secondary.main, 0.05),
            80: muiTheme.palette.secondary.main,
            90: darken(muiTheme.palette.secondary.main, 0.2),
            100: darken(muiTheme.palette.secondary.main, 0.3),
          },
        },
      },
    },
  });

  return awsTheme;
};
